import { useState } from 'react'
import PagesManagement from './PagesManagement'
import MenuManagement from './MenuManagement'
import FooterSettings from './FooterSettings'
import FileManager from './FileManager'

export default function CMSManagement() {
  const [activeTab, setActiveTab] = useState('pages')

  const tabs = [
    { id: 'pages', label: 'Seiten' },
    { id: 'media', label: 'Dateimanager' },
    { id: 'menu', label: 'Menü' },
    { id: 'footer', label: 'Footer-Einstellungen' },
  ]

  return (
    <div>
      <h1 style={{ fontSize: 24, margin: '0 0 24px' }}>Seiten-Verwaltung</h1>

      <div className="wc-seg" role="tablist" style={{ marginBottom: 24, alignSelf: 'flex-start' }}>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-pressed={activeTab === tab.id}
            onClick={() => setActiveTab(tab.id)}
            className="wc-seg-opt"
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div>
        {activeTab === 'pages' && <PagesManagement />}
        {activeTab === 'media' && <FileManager />}
        {activeTab === 'menu' && <MenuManagement />}
        {activeTab === 'footer' && <FooterSettings />}
      </div>
    </div>
  )
}
